export default "__VITE_ASSET__1gS4dtFx__"